import { render, staticRenderFns } from "./Grade.vue?vue&type=template&id=8fe31f2c&scoped=true"
import script from "./Grade.vue?vue&type=script&lang=js"
export * from "./Grade.vue?vue&type=script&lang=js"
import style0 from "./Grade.vue?vue&type=style&index=0&id=8fe31f2c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe31f2c",
  null
  
)

export default component.exports